import React from "react";
import classNames from "classnames";

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
    containerRef?: React.RefObject<any>;
    className?: any;
}

export const TabPanel: React.FunctionComponent<TabPanelProps> = ({
    children,
    value,
    index,
    containerRef,
    className,
    ...other
}) => {
    return (
        <div
            role="tabpanel"
            className={classNames("tabpanel", className)}
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            ref={containerRef}
            {...other}
        >
            {value === index && <> {children}</>}
        </div>
    );
};
